import { ID } from "src/libs/interfaces/layouts"
import { IPanel } from "./interface"
import Panel from "./Panel"
import { allPanelData } from "./PanelLayout"

/* Protopia Ecosystem component */
export interface IFloatPanelProps {
    data: IPanel[]
    onPosition: ( x:number, y: number, w: number, h: number, panelId: ID, consoleId: ID ) => void
    setActivePanelDataId: ( panelDataId: ID, panelId: ID) => void
    onThread: ( panelId: ID, consoleId: ID, isTread: boolean, x:number, y: number, w: number, h: number, ) => void
    onCompact: ( panelId: ID, isCompact: boolean ) => void
    onClose: ( panelId: ID ) => void
}
const FloatPanel = (props: IFloatPanelProps): JSX.Element => {
    const onPosition = ( x:number, y: number, w: number, h: number, id: ID ) => {        
        // console.log(  x, y, w, h, id, -1  )        
        props.onPosition( x, y, w, h, id, -1 )
    }
    const onThread = (  panelId: ID, consoleId:ID, _isTread: boolean, x:number, y: number, w: number, h: number, ) => {
        props.onThread( panelId, consoleId, _isTread, x, y , w, h )
    } 
    const onCompact = (panelId: ID, isOpen: boolean ) => { 
        props.onCompact(panelId, isOpen)
    }
    return <div className='pe-float-panels'>
       {
            props.data.map(panel => { 
                return <Panel
                    key={ panel.id }
                    id={ panel.id }
                    activeId={ panel.activeId || panel.panelDatas[0]?.id }
                    data={
                        panel.panelDatas.map( pd => {  
                            return {
                                id: pd.id,
                                title: pd.title,
                                icon: pd.icon,
                                data: allPanelData()[ pd.id ]?.component || <></>
                            }
                        })
                    }
                    onClose={() => props.onClose( panel.id ) }
                    onThread={onThread}
                    onCompact={onCompact}
                    isTread= { panel.isTread }
                    isOpen={ panel.isOpen }
                    x={ panel.x }
                    y={ panel.y }
                    w={ panel.w }
                    h={ panel.h }
                    setActiveId={(panelDataId: ID) => props.setActivePanelDataId(panelDataId, panel.id)}
                    onPosition={ ( x:number, y: number, w: number, h: number ) => onPosition( x, y, w, h, panel.id )}
                />
            })
        }
    </div>
}
export default FloatPanel